import React, { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'
import { actionCreators as passwordActions } from '@/store/Password'
import { Form, Row, Col } from 'reactstrap'
import ChangePassword from './changePassword'
import RsaKeys from './rsaKeys'
import PersonalAccessTokens from './personalAccessTokens'
import Resx from '@/components/Resx'
import { Main, MainTop, MainTopTitle, MainBody, WhiteBox } from '@/components/Layout'
import { TabNavItems, TabContent, TabPane } from '@/components/tabs'
import { Detail as UserInfo } from '@/components/usersManagement'
import context from '@/context'
import { DataLoader } from '@/components/dataLoader'
import LoadingIndicator from '@/components/LoadingIndicator'
import IndividualDetail from './individualDetail'
import NotificationConfigurations from './notificationConfigurations'
import LanguageSettings from './languageSettings'
import TwoFactor from './twoFactor'
import { Impersonation } from '@/components/userProfile/impersonation'
import { useLocalization } from '@/hooks/localization'
import { useDispatch } from '@/hooks/dispatch'
import { Button } from '@/components/button'
import { actionCreators as identityActions } from '@/store/Identity'
import debug from 'debug'
const log = debug('app:menu')

function UserProfile (props) {
  const { localize } = useLocalization()
  const [state, setState] = useState({ activeTab: '1' })

  const [ clearError, userExpired, loadUser ] = useDispatch([
    passwordActions.clearError,
    identityActions.userExpired,
    identityActions.loadUser
  ])

  const { userName, impersonatorUserId } = useSelector(state => {
    return {
      userName: state.identity.user.profile.name,
      impersonatorUserId: state.identity.user.profile.ImpersonatorUserId
    }
  })

  const items = [
    { id: '1', text: 'UserProfile.PersonalInfo', icon: 'user-detail' },
    { id: '2', text: 'UserProfile.Security', icon: 'key' },
    { id: '3', text: 'UserProfile.Api', icon: 'transfer' },
    { id: '4', text: 'UserProfile.NotificationSettings', icon: 'envelope' },
    { id: '5', text: 'UserProfile.LanguageSettings', icon: 'globe' }
  ]

  const toggle = useCallback((tab) => {
    if (state.activeTab !== tab) {
      setState({
        activeTab: tab
      })
      clearError()
    }
  }, [clearError, state.activeTab])

  const stopImpersonation = useCallback(() => {
    context.api.loginService.stopImpersonation()
      .then(() => {
        userExpired()
        loadUser()
      }).catch((err) => {
        log(err)
      })
  }, [loadUser, userExpired])

  if (impersonatorUserId) {
    return (
      <Main>
        <WhiteBox header='UserProfile.CurrentlyImpersonatingHeader'>
          <Row>
            <Col lg='6'>
              <p>{localize('UserProfile.CurrentlyImpersonatingBody')}</p>
              <Button onClick={stopImpersonation} >{localize('UserProfile.StopImpersonation')}</Button>
            </Col>
          </Row>
        </WhiteBox>
      </Main>
    )
  }

  return (
    <Main>
      <MainTop>
        <MainTopTitle>
          <Resx name='Security.UserProfileTitle' />:
          {userName}
        </MainTopTitle>
      </MainTop>

      <MainBody className='profile-page' transparent>
        <Form>
          <Row>
            <Col>
              <TabNavItems
                activeTabId={state.activeTab}
                onClick={tabId => toggle(tabId)}
                items={context.isInternalApp() ? [...items, { id: '6', text: 'UserProfile.Impersonation', icon: 'group' }] : items}
              />
              <TabContent className='white-box white-box-profile' activeTab={state.activeTab}>
                <TabPane tabId='1'>
                  <DataLoader dataSource={() => context.api.userManagementService.getUserForUserProfile()} render={({ data, loading }) => (
                    loading
                      ? <LoadingIndicator />
                      : <UserInfo user={data} showMyPhone headerText={localize('UserProfile.User')} hideIsInternalUser />
                  )} />

                  <DataLoader dataSource={() => context.api.individualService.getIndividualForUserProfile()} render={({ data, loading }) => (
                    loading
                      ? <LoadingIndicator />
                      : <IndividualDetail individual={data} headerText={localize('UserProfile.Individual')} />
                  )} />
                </TabPane>
                <TabPane tabId='2'>
                  <Row>
                    <Col lg='6'><ChangePassword /></Col>
                    <Col lg='6'><TwoFactor localize={localize} /></Col>
                  </Row>

                  <RsaKeys />
                </TabPane>
                <TabPane tabId='3'>
                  <PersonalAccessTokens />
                </TabPane>
                <TabPane tabId='4'>
                  <NotificationConfigurations appType={props.appType} />
                </TabPane>
                <TabPane tabId='5'>
                  <LanguageSettings appType={props.appType} />
                </TabPane>
                {context.isInternalApp() && <TabPane tabId='6'>
                  <Impersonation />
                </TabPane>}
              </TabContent>
            </Col>
          </Row>
        </Form>
      </MainBody>
    </Main>
  )
}

export default UserProfile



// WEBPACK FOOTER //
// ./src/components/userProfile/index.js